import * as pdfjs from 'pdfjs-dist';
import _ from 'lodash-es';
// @ts-ignore
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
// @ts-ignore
import ExtractText from '@knitiv/wkpdf/dist/extract/text';
// @ts-ignore
import ExtractSignatures from '@knitiv/wkpdf/dist/extract/signatures';
import templateModalPdfDataExtracted from './modal/pdf-data-extracted/modal-pdf-data-extracted.html';
import ModalPdfDataExtractedController from './modal/pdf-data-extracted/modal-pdf-data-extracted.controller';
import templateModalPdfSignatures from './modal/pdf-signatures/modal-pdf-signatures.html';
import ModalPdfSignaturesController from './modal/pdf-signatures/modal-pdf-signatures.controller';

export default class PdfUtils {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
		this.$rootScope = $injector.get('$rootScope');
		this.$timeout = $injector.get('$timeout');
		this.$uibModal = $injector.get('$uibModal');
	}

	/**
	 * @param {ArrayBuffer} data
	 * @param {any} options
	 * @returns {Promise<any>}
	 */
	async extractText(data, options) {
		const extractText = new ExtractText(options);
		await extractText.loadRaw(data);
		const propositions = await extractText.extract();
		return this.showModalPropositions(propositions);
	}

	/**
	 * @param {ArrayBuffer} data
	 * @returns {any[]}
	 */
	getSignatures(data) {
		const extractSignatures = new ExtractSignatures();
		try {
			return extractSignatures.extractSignatures(data);
		}
		catch (error) {
			console.warn(error);
		}
		return [];
	}

	/**
	 * @param {any[]} propositions
	 * @param {any} [options]
	 * @returns {Promise<any>}
	 */
	async showModalPropositions(propositions, options = {}) {
		let modalPropositions;

		if (propositions.length > 0) {
			modalPropositions = await this.$uibModal.open({
				backdrop:     false,
				controller:   ModalPdfDataExtractedController,
				controllerAs: '$ctrl',
				resolve:      {
					options,
					propositions: () => _.uniqWith(
						propositions, (a, b) => _.isEqual(a.assignto, b.assignto)
						&& a.str === b.str,
					),
				},
				size:         'sm',
				template:     templateModalPdfDataExtracted,
				windowClass:  'modal-upload',
			}).result;
		}
		return modalPropositions;
	}

	/**
	 * @param {any} signatures
	 */
	showModalSignatures(signatures) {
		this.$uibModal.open({
			controller:   ModalPdfSignaturesController,
			controllerAs: '$ctrl',
			resolve:      {
				signatures: () => signatures,
			},
			template:     templateModalPdfSignatures,
		});
	}
}
